import StyledAutocomplete from '@components/styled-autocomplete';
import { TypeReturn } from '@components/styled-autocomplete/useStyledAutocomplete';
import { ListProps } from '@Core';
import { Camera } from '@EcamModel/model';
import { Box, Button, Divider, Stack, Typography } from '@mui/material';
import Grid2 from '@mui/material/Unstable_Grid2/Grid2';
import color from '@theme/Colors';
import { CSSProperties, ReactNode } from 'react';

export default function DetailInfoSection(props: {
    icon?: JSX.Element;
    title: string;
    content: ReactNode;
    action?: ReactNode;
    borderRadius?: CSSProperties['borderRadius'];
    camerasAutocomplete?: TypeReturn<Camera, ListProps<Camera>>;
    selectedCamera?: Camera;
    handleChangeCamera?: (camera: Camera) => void;
}) {
    return (
        <Stack
            direction={'column'}
            width={'100%'}
            border={`1px solid ${color.grey300}`}
            borderRadius={props.borderRadius || '8px'}
        >
             {props.camerasAutocomplete && (
                <Stack sx={{ padding: '16px 16px 0px' }}>
                    <StyledAutocomplete
                        {...props.camerasAutocomplete}
                        isRequired
                        getOptionLabel={(o) => o?.Name}
                        label="Camera"
                        value={props.selectedCamera}
                        placeholder="Select camera"
                        disabledAllOption
                        onChange={props.handleChangeCamera}
                        wrapperWidth="100%"
                    />
                </Stack>
            )}
            <Stack
                direction={'row'}
                justifyContent={'space-between'}
                alignItems={'center'}
                gap={1}
                sx={{
                    borderRadius: '4px 4px 0px 0px',
                    padding: '12px 16px',
                    position: 'relative',
                }}
            >
                <Typography variant="h5" mt={'2px'}>
                    {props.title}
                </Typography>
                {props.action}
            </Stack>

            <Divider
                orientation="horizontal"
                sx={{
                    borderBottomWidth: 1,
                    borderColor: color.grey300,
                    mx: 2,
                }}
            />

            {props.content}
        </Stack>
    );
}

export const DetailInfoItem = (props: { leftContent: string; rightContent: string | ReactNode | undefined }) => {
    return (
        <Grid2 container display={'flex'}>
            <Grid2 xs={5} padding={'8px 16px'}>
                <Typography mt={'2px'}>{props.leftContent}</Typography>
            </Grid2>
            <Grid2 xs={7} padding={'8px 16px'}>
                <Typography mt={'2px'}>{props.rightContent ?? ''}</Typography>
            </Grid2>
        </Grid2>
    );
};
